import { Injectable } from '@angular/core';
import { IAdapter } from 'src/app/lego-utils';
import { toInteger } from 'lodash-es';
import { BOMHeader } from 'src/app/models/domain';
import { IBomHeaderPost } from 'src/app/models/domain/bom-header-post';
import { IBomHeaderUpdate } from 'src/app/models/domain/bom-header-update';
import { YPLMBOMSRVBomHeader } from 'src/generated-clients/bom';

@Injectable({
  providedIn: 'root',
})
export class BOMHeaderAdapter implements IAdapter<BOMHeader, IBomHeaderPost, IBomHeaderUpdate> {
  public get $select() {
    const propertyNames: Array<keyof YPLMBOMSRVBomHeader> = [
      'HeaderMaterial',
      'Plant',
      'Usage',
      'Alternative',
      'BomStatus',
    ];

    return [...propertyNames];
  }

  public adaptToDTO(header: Partial<BOMHeader>): Partial<IBomHeaderUpdate> {
    return {
      BomStatus: header.status?.toString(),
    };
  }

  public adaptToPost(model: Partial<BOMHeader>): Partial<IBomHeaderPost> {
    return {
      HeaderMaterial: model.material,
      Usage: model.usage,
      Plant: model.plant,
      Alternative: model.altBom,
    };
  }

  public adaptToDomain(header: YPLMBOMSRVBomHeader): BOMHeader {
    return new BOMHeader(
      header.HeaderMaterial ?? '',
      header.Plant ?? '',
      header.Usage ?? '',
      header.Alternative ?? '',
      header.BomStatus ? toInteger(header.BomStatus) : 0
    );
  }
}
